module.exports = __webpack_public_path__ + "img/noData.1941c9a7.svg";